import React from "react";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { ReassignRoleTargetCombobox } from "./ReassignRoleTargetCombobox";

interface Props {
    items: Array<PickerItemData<string>>;
    value: string | null;
    onChange: (id: string | null) => void;
    emptyNoun: string;
    isLoading?: boolean;
}

export const ReassignRoleTargetPicker: React.FC<Props> = ({
    items,
    value,
    onChange,
    emptyNoun,
    isLoading = false,
}) => {
    if (isLoading) {
        return <p className="mb-0">Loading…</p>;
    }
    if (items.length === 0) {
        return (
            <p className="mb-0">
                No eligible account exists in this {emptyNoun} for this role.
            </p>
        );
    }
    return (
        <ReassignRoleTargetCombobox
            items={items}
            value={value}
            onChange={onChange}
        />
    );
};
